import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Returns to the top of the page on navigation.
 *
 * A single-page app keeps the scroll position across route changes by default, which means
 * following a link from halfway down the houses page lands you halfway down the cottage
 * page. Hash links are left alone so in-page anchors still work.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) return
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior })
  }, [pathname, hash])

  return null
}
